import React from "react";
import PropTypes from "prop-types";

import ReconciliationRow from "./ReconciliationRow";

const ReconciliationEntry = ({
  displayName,
  reconciliationDataFieldName,
  reconciliationData,
  classes,
  isNegative,
  dontShowBeforeYear,
  enableVarianceHighlight,
}) => (
  <ReconciliationRow
    displayName={displayName}
    reconciliationDataFieldName={reconciliationDataFieldName}
    reconciliationData={reconciliationData}
    classes={classes}
    insertDivider={false}
    bold={false}
    underlined={false}
    isNegative={isNegative}
    hasLeftMargin
    hasVerticalSpacing={false}
    dontShowBeforeYear={dontShowBeforeYear}
    enableVarianceHighlight={enableVarianceHighlight}
  />
);

ReconciliationEntry.propTypes = {
  displayName: PropTypes.string.isRequired,
  reconciliationDataFieldName: PropTypes.string.isRequired,
  reconciliationData: PropTypes.shape({
    years: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number.isRequired,
      })
    ),
    cumulative: PropTypes.objectOf(PropTypes.number),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- See reconciliationTableStyles
  classes: PropTypes.object.isRequired,
  isNegative: PropTypes.bool,
  dontShowBeforeYear: PropTypes.number,
  enableVarianceHighlight: PropTypes.bool,
};

ReconciliationEntry.defaultProps = {
  isNegative: false,
  dontShowBeforeYear: undefined,
  enableVarianceHighlight: false,
};

export default ReconciliationEntry;
